module.exports = __webpack_public_path__ + "media/images/team/DianaSantos-c84341a602b168eff1a47b16b982a2f6.png";